export class SimpleDataDto {
  id!: number;
  name!: string;
  otherData?: any;
}

export class BudgetCounterDto {
  drivers: number = 0;
  additional_costs: number = 0;
  driver_invoices: number = 0;
  client_invoices: number = 0;
}